import axios from 'axios';
import { Modal } from 'bootstrap';
import { sistemaNameSSO } from '../config/system';
import { urlsServices } from '../config/urls';
import { getEncodeAvatarUsuario, getTokenSSO, setTokenSSO } from '../utils';

let urlsSSO = {};
urlsSSO.DOMINIO = urlsServices.SSOWS;
urlsSSO.VALIDATE = `${urlsSSO.DOMINIO}validate?token=`;
urlsSSO.LOGOUT = `${urlsSSO.DOMINIO}logout?token=`;

export const logoutUser = async (token) => {
  await axios.get(`${urlsSSO.LOGOUT}${token ? token : getTokenSSO()}`, {
    cache: {
      maxAge: 0,
    },
  });
  window.location.href = getUrlLogin();
};

export const getUrlLogin = () => {
  return `${urlsSSO.DOMINIO}auth?response_type=token_only&client_id=${sistemaNameSSO}&redirect_uri=${encodeURIComponent(window.location.href.replace('#', '|'))}`;
};

const prepareDataUser = (dadosUsuario) => {
  if (dadosUsuario.perfis) {
    let thisPerfis = [];
    dadosUsuario.perfis.forEach((perfil) => {
      if (perfil.sistema.descricao.toUpperCase() === sistemaNameSSO.toUpperCase()) {
        if (!thisPerfis.includes(perfil.descricao.toUpperCase())) thisPerfis.push(perfil.descricao.toUpperCase());
      }
    });
    if (!thisPerfis || thisPerfis.length < 1) {
      dadosUsuario.semPerfilThisSistema = true;
    } else {
      dadosUsuario.perfisSistemaAtual = thisPerfis;
    }
  }
  dadosUsuario.iconUser = `${urlsServices.SIGUWS}icon?u=${getEncodeAvatarUsuario(dadosUsuario.cpf)}`;
  return dadosUsuario;
};

export const postMessageTokenIframe = (tokenParam) => {
  if (tokenParam && window.parent.length) {
    window.parent.postMessage({ iframeSSOToken: { token: tokenParam } }, window.location.origin);
  } else {
    window.parent.postMessage({ iframeSSOToken: { close: true } }, window.location.origin);
  }

  window.addEventListener('message', (e) => {
    const { origin = '' } = e;

    if (String(origin).indexOf('https://sso') > -1 || String(origin).indexOf(window.location.origin) > -1) {
      const { data = {} } = e;
      if (data && typeof data === 'object' && data.iframeSSOToken) {
        if (data.iframeSSOToken.token) setTokenSSO(data.iframeSSOToken.token);

        let myModalEl = document.getElementById('modal-iframe-sso');
        if (myModalEl) {
          let modal = Modal.getInstance(myModalEl);
          if (modal) {
            modal.hide();
          }
        }
      }
    }
  });
};

export const checkLoginSSO = async (token) => {
  const response = await axios.get(`${urlsSSO.VALIDATE}${token ? token : getTokenSSO()}`, {
    cache: {
      maxAge: 0,
    },
  });
  if (response.data) {
    return {
      ...prepareDataUser(response.data),
      isAuthenticated: true,
    };
  }
  return { isAuthenticated: false };
};

export const modalLoginSSO = () => {
  const htmlModal = `
	<div id="modal-iframe-sso" class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Login SSO</h5>
					<button type="button" style="visibility: hidden;" id="modal-iframe-sso-close" data-bs-dismiss="modal" aria-label="Close"></button>				
				</div>
				<div class="modal-body" style="height: 90vh;">
					<iframe src=${getUrlLogin()} width="100%" height="100%" loading="Aguarde..." frame-border="0" allow-full-screen="true" />
				</div>			
			</div>
		</div>
	</div>
	`;
  document.querySelectorAll('#modal-iframe-sso').forEach((modalSSO) => {
    if (modalSSO) {
      let modal = Modal.getInstance(modalSSO);
      if (modal) {
        modal.hide();
        if (modalSSO) modalSSO.remove();
      }
    }
  });
  var elem = document.createElement('div');
  elem.innerHTML = htmlModal;
  document.body.appendChild(elem);
  var modalIframeSSO = Modal.getOrCreateInstance(document.getElementById('modal-iframe-sso'), {
    backdrop: 'static',
    keyboard: false,
  });
  modalIframeSSO.show();
};
